export const YarnMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 44 44" fill="none" className={className} aria-hidden="true">
    <circle cx="20" cy="22" r="14" stroke="currentColor" strokeWidth="2.4" />
    <path d="M8 18c6-5 18-5 24 0M8 26c6 5 18 5 24 0M14 10c-3 8-3 16 0 24M26 10c3 8 3 16 0 24" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M33 31c4 2 7 5 8 9" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

export const StitchDiamond = ({ className = "h-2.5 w-2.5" }) => (
  <svg viewBox="0 0 10 10" className={className} aria-hidden="true">
    <rect x="2" y="2" width="6" height="6" rx="1" transform="rotate(45 5 5)" fill="currentColor" />
  </svg>
);
